import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IDocumentContentPreview {
    comment: string;
    content: string;
    createUser: IModifyUser;
    modifyUser: IModifyUser;
    errorMessage: string;
}

export class DocumentContentPreview implements IDocumentContentPreview {
    comment: string;
    content: string;
    createUser: ModifyUser;
    modifyUser: ModifyUser;
    errorMessage: string;

    constructor();
    constructor(obj: IDocumentContentPreview);
    constructor(obj?: any) {
        this.comment = obj && obj.comment || "";
        this.content = obj && obj.content || "";
        this.createUser = null;
        if (obj?.createUser) {
            this.createUser = new ModifyUser(obj.createUser);
        }
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.errorMessage = obj && obj.errorMessage || "";
    }
}
